export default __webpack_public_path__ + "static/media/man-with-stars.e5d28c8a.svg";